import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unassignedMerchantsKeys } from "Api/Queries/Merchants/useUnassignedMerchantsQuery";
import {
  type AssignHunterToUnassignedMerchantRequest,
  type AssignHunterToUnassignedMerchantResult,
  postAdminMerchantsUnassignedMerchantPublicIDAssignHunter,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type MutationInput = {
  merchantPublicID: string;
  request: AssignHunterToUnassignedMerchantRequest;
};

type Props = {
  onSuccess?: (result: AssignHunterToUnassignedMerchantResult) => void;
  onError?: (error: unknown) => void;
};

export const useAssignHunterToMerchantMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, request }: MutationInput) =>
        postAdminMerchantsUnassignedMerchantPublicIDAssignHunter(
          request,
          merchantPublicID,
        ),
    ),
    onSuccess: (result: AssignHunterToUnassignedMerchantResult) => {
      queryClient.invalidateQueries({ queryKey: unassignedMerchantsKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
